























import { Vue, Component } from "vue-property-decorator";
import { collections } from "@/configs/firebase";
import logger from "@/configs/logger";
import moment from "moment";

@Component
export default class TwilioEvents extends Vue {
  search: string = "";
  items: any[] = [];
  loading: boolean = false;
  headers = [
    {
      text: "Insurita Time",
      align: "start",
      filterable: true,
      value: "InsuritaTime"
    },
    { text: "Event Type", value: "EventType" },
    { text: "Assignment Status", value: "TaskAssignmentStatus" },
    { text: "Queue", value: "TaskQueueName" },
    { text: "Worker", value: "WorkerName" },
    { text: "Twilio Time", value: "TwilioTime" }
  ];

  async created() {
    try {
      this.loading = true;
      const snapshot = await collections.twilioEvents
        .where("TaskSid", "==", this.$route.params.taskSID)
        .orderBy("created_ts")
        .get();

      this.items = snapshot.docs.map(doc => {
        const val = doc.data();
        return {
          ...val,
          TwilioTime: this.getDate(val.TimestampMs / 1000),
          InsuritaTime: this.getDate(
            val.created_ts.seconds + val.created_ts.nanoseconds / 1000000000
          )
        };
      });
    } catch (err) {
      logger("error", err);
      this.$toasted.error("Fetch events error.").goAway(2000);
    } finally {
      this.loading = false;
    }
  }

  getDate(timestamp: number): string {
    return moment.unix(timestamp).format("MMM DD YY, h:mm:ss.SSS a");
  }
}
